import React, { useState, useEffect } from "react";
import "./index.scss";
import { useLocation, useHistory } from "react-router-dom";
import ContentTabs from "./components/ContentTabs";
import POContent from "./components/POContent/POContent";
import InventoryContent from "./components/InventoryContent/InventoryContent";
import SupplierContent from "./components/SupplierContent/SupplierContent";
import POFilter from "./components/POContent/POFilter";
import InventoryFilter from "./components/InventoryContent/InventoryFilter";
import SupplierFilter from "./components/SupplierContent/SupplierFilter";

const POSupplierDevice = () => {
  const location = useLocation();
  const history = useHistory();

  const [showPOCreateModal, setShowPOCreateModal] = useState(false);
  const [inventorySearch, setInventorySearch] = useState("");
  const [showInventoryCreateModal, setShowInventoryCreateModal] =
    useState(false);
  const [poNumber, setPONumber] = useState("");
  const [supplierSearch, setSupplierSearch] = useState("");
  const [showSupplierCreateModal, setShowSupplierCreateModal] = useState(false);

  const [contentTab, setContentTab] = useState(() => {
    const params = new URLSearchParams(location.search);
    const subtabFromUrl = params.get("subtab");
    const defaultSubtab = "po";

    if (
      subtabFromUrl &&
      ["po", "inventory", "supplier"].includes(subtabFromUrl)
    ) {
      return subtabFromUrl;
    }
    return defaultSubtab;
  });

  const contentTabs = [
    {
      id: "po",
      label: "PO",
    },
    {
      id: "inventory",
      label: "Inventory",
    },
    {
      id: "supplier",
      label: "Supplier",
    },
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentSubtab = params.get("subtab");

    if (
      !currentSubtab ||
      !["po", "inventory", "supplier"].includes(currentSubtab)
    ) {
      params.set("subtab", contentTab);
      history.replace(`${location.pathname}?${params.toString()}`);
    } else if (contentTab !== currentSubtab) {
      params.set("subtab", contentTab);
      history.replace(`${location.pathname}?${params.toString()}`);
    }
  }, [contentTab, history, location.search, location.pathname]);

  const handleContentTabChange = (tabId) => {
    setContentTab(tabId);
  };

  const handleCreatePO = () => {
    setShowPOCreateModal(false);
  };
  const handleCreateInventory = () => {
    setShowInventoryCreateModal(false);
  };
  const componentMap = {
    po: (
      <POContent
        showPOCreateModal={showPOCreateModal}
        setShowPOCreateModal={setShowPOCreateModal}
        searchText={poNumber}
        handleCreatePO={handleCreatePO}
      />
    ),
    inventory: (
      <InventoryContent
        showInventoryCreateModal={showInventoryCreateModal}
        setShowInventoryCreateModal={setShowInventoryCreateModal}
        searchText={inventorySearch}
        onCreateInventory={handleCreateInventory}
      />
    ),
    supplier: (
      <SupplierContent
        showSupplierCreateModal={showSupplierCreateModal}
        setShowSupplierCreateModal={setShowSupplierCreateModal}
        searchText={supplierSearch}
      />
    ),
  };

  const filterComponentMap = {
    po: (
      <POFilter
        poNumber={poNumber}
        setPONumber={setPONumber}
        setShowPOCreateModal={setShowPOCreateModal}
      />
    ),
    inventory: (
      <InventoryFilter
        inventoryNumber={inventorySearch}
        setInventoryNumber={setInventorySearch}
        setShowInventoryCreateModal={setShowInventoryCreateModal}
      />
    ),
    supplier: (
      <SupplierFilter
        supplierSearch={supplierSearch}
        setSupplierSearch={setSupplierSearch}
        setShowSupplierCreateModal={setShowSupplierCreateModal}
      />
    ),
  };

  return (
    <div className="content-section">
      <div className="content-header">
        <ContentTabs
          tabs={contentTabs}
          contentTab={contentTab}
          setContentTab={handleContentTabChange}
        />
        {filterComponentMap[contentTab] && (
          <>{filterComponentMap[contentTab]}</>
        )}
      </div>
      <div className="content-body">{componentMap[contentTab]}</div>
    </div>
  );
};

export default POSupplierDevice;
